import { inUseFwAPI } from '../api/FwrsAPI'

export function useFwrs() {
  const onInUseFw = async (fw_id: number) => {
    try {
      const result = await inUseFwAPI(fw_id)
      return result
    } catch (e) {
      console.error("fwrs 데이터를 가져오는 중 에러 발생:", e)
    }
  }
  return {
    onInUseFw
  }
}